export interface MassageUsagesComponentProps {
    // Self-contained, no props needed
}

export const MassageUsagesComponent = {
    MountAsync: async (target: HTMLElement, props: MassageUsagesComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { MassageUsagesComponent } = await import('./MassageUsagesComponent');
        return await mountReactComponentAsync(target, MassageUsagesComponent, props);
    }
};
